class Controller {
  constructor($mdDialog) {
    "ngInject";

    this.$mdDialog = $mdDialog;
  }

  close() {
    this.$mdDialog.cancel();
  }

  checkLength(pin) {
    return pin.toString().length !== 4;
  }

  confirm() {
    this.$mdDialog.hide(this.newPin.toString());
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captain/pinDialog/pinDialog.controller.js